import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Address, Organization, OrganizationStatus } from "../helpers/organizationHelper";

export const initialState: Organization = {
    address: {} as Address,
    agreeTerms: false,
    orgName: "",
    status: OrganizationStatus.deleted
};

const organizationSlice = createSlice({
    name: "organization",
    initialState,
    reducers: {
        updateOrganization(state, action: PayloadAction<Organization>) {
            state.address = action.payload.address;
            state.orgName = action.payload.orgName;
            state.agreeTerms = action.payload.agreeTerms;
            state.npiNumber = action.payload.npiNumber;
            state.agreeTermsStamp = action.payload.agreeTermsStamp;
            state.primaryContact = action.payload.primaryContact;
            state.administrator = action.payload.administrator;
            state.id = action.payload.id;
            state.activeStaffUsers = action.payload.activeStaffUsers;
            state.inactiveStaffUsers = action.payload.activeStaffUsers;
            state.status = action.payload.status;
        },
        updateStaffCounts(state, action: PayloadAction<{ active: number; inactive: number }>) {
            state.activeStaffUsers = action.payload.active;
            state.inactiveStaffUsers = action.payload.inactive;
        }
    }
});

export const { updateOrganization, updateStaffCounts } = organizationSlice.actions;

export default organizationSlice.reducer;
